import React from 'react'
import { Field, FieldProps, FieldRenderProps } from 'react-final-form'
import CheckBox from 'components/ui/CheckBox'

type CheckBoxProps = {
  description?: React.ReactElement | string
  label: React.ReactElement | string
  newDesign?: boolean
}

export type Props = CheckBoxProps & {
  name: string
  size?: 'base' | 'large'
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldProps?: Partial<FieldProps<any, any>>
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EMPTY_FIELD_PROPS: Partial<FieldProps<any, any>> = {}

function InnerField({
  description,
  label,
  input,
  size,
  newDesign,
  meta: { touched, error: syncError, submitError }
}: FieldRenderProps<boolean, HTMLInputElement> & CheckBoxProps) {
  const error = syncError || submitError
  const showError = (touched || submitError) && !!error
  return (
    <CheckBox
      description={description}
      error={showError ? error : null}
      label={label}
      newDesign={newDesign}
      onChange={(value) => {
        input.onChange(value)
        input.onBlur()
      }}
      size={size}
      value={input.value}
    />
  )
}

export default function FormCheckBox({
  name,
  fieldProps = EMPTY_FIELD_PROPS,
  ...innerProps
}: Props) {
  return (
    <Field<
      boolean,
      FieldRenderProps<boolean, HTMLInputElement>,
      HTMLInputElement
    >
      name={name}
      render={(props) => <InnerField {...props} {...innerProps} name={name} />}
      {...fieldProps}
    />
  )
}
